import React from "react";

export const AppLogoIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1024 1024"
    aria-label="Who's In?"
    role="img"
    {...props}
  >
    <defs>
      <radialGradient id="g" cx="50%" cy="40%" r="60%">
        <stop offset="0%" stopColor="#9F7AEA" />
        <stop offset="100%" stopColor="#6B46C1" />
      </radialGradient>
    </defs>
    {/* Outer circle */}
    <circle cx="512" cy="512" r="512" fill="url(#g)" />
    {/* Middle circle */}
    <circle cx="512" cy="512" r="320" fill="white" opacity="0.06" />
    {/* Inner circle */}
    <circle cx="512" cy="512" r="160" fill="white" opacity="0.12" />
  </svg>
);
